import clsx from 'clsx';
import styles from './envBadge.module.css';

// Vite MODE comes from the `--mode` flag, so it is consistent across the three
// apps (`.env.develop` / `.env.testing` / `.env.production`). `pnpm dev` runs
// with the `development` mode. Production is intentionally absent: no badge.
const ENV_LABEL: Record<string, string> = {
  development: 'LOCAL',
  develop: 'DEV',
  testing: 'TEST'
};

const EnvBadge: React.FC = () => {
  const mode = import.meta.env.MODE;
  const label = ENV_LABEL[mode];

  if (!label) {
    return null;
  }

  return (
    <>
      <span className={clsx(styles.strip, styles[mode])} aria-hidden />
      <span className={clsx(styles.badge, styles[mode])}>{label}</span>
    </>
  );
};

export default EnvBadge;
